// extracted by mini-css-extract-plugin
module.exports = {"name-input-container":"_10BlwgMSQAhOpnIfGGbzTd","title":"_1rxjXvVfPYJmFJ2LNx7J7Z"};